var DialogView = require('dialogview');
var FileWrapper = require('filewrapper');


var FileUploadDialogView = DialogView.extend({
    el: '#fileUploadContainer',
    initialize: function (options) {
        this.form = $('#fileUploadForm');

        this.batch = this.$('.batch');
        this.tree = this.$('.treeContainer');
        this.maxUploadBatchInfo = this.$('.maxUploadBatchInfo');
        this.maxUploadBatch = this.$('.maxUploadBatch');

        this.single = this.$('.single');
        this.previewWrapper = this.$('.previewWrapper');
        this.heading = this.$('.heading');
        this.info = this.$('.info');
        this.dropped = this.$('.dropped');
        this.nameInput = $('#uploadPreviewName');
        
        this.messageInput = $('#uploadPreviewMessage');

        this.sendAsText = this.$('.sendAsText');

        this.init();
        this.afterHide = _.bind(this.init, this);

        DialogView.prototype.initialize.apply(this, arguments);
    },
    events: $.extend({}, DialogView.prototype.events, {
        'submit #fileUploadForm': 'submitPreview',
        'buttonClick .sendAsText': 'clickSendAsText'
    }),
    init: function () {
        if (this.onCancel && !this.confirmed) {
            this.onCancel();
        }
        this.buffer = null;
        this.onConfirm = null;
        this.onCancel = null;
        this.confirmed = null;

        this.renderHeading();

        this.$el.removeClass('batch');

        this.batch.hide();
        this.tree.empty();
        this.maxUploadBatchInfo.hide();

        this.single.hide();
        this.previewWrapper.empty();
        this.info.empty();
        this.dropped.hide();
        this.sendAsText.hide();
        this.nameInput.val('');
        this.messageInput.val('');
        this.enableForm();
    },
    renderHeading: function (buffer, multiple) {
        var file = multiple ? 'files' : 'a file';
        var base = 'Upload ' + file;
        if (buffer) {
            this.heading.text(base + ' to ' + buffer.getTitle());
        } else {
            this.heading.text(base);
        }
    },
    
    isDisabled: function () {
        return this.disabled;
    },
    disableForm: function () {
        if (!this.isDisabled()) {
            this.disabled = true;
            this.$('input, button, textarea').blur().prop('disabled', true);
        }
    },
    enableForm: function () {
        if (this.isDisabled()) {
            this.disabled = false;
            this.$('input, button, textarea').prop('disabled', false);
        }
    },
    submitPreview: function (e) {
        e.preventDefault();
        if (this.isDisabled()) {
            return;
        }
        var data = this.form.serializeForm();
        this.disableForm();
        this.onConfirm(data);
        this.done();
    },
    clickSendAsText: function (e) {
        e.preventDefault();
        if (this.isDisabled()) {
            return;
        }
        this.disableForm();
        this.buffer.say(this.options.dataURI);
        this.done();
    },
    done: function () {
        this.confirmed = true;
        this.hide();
    },
    showBatch: function (fileTree, buffer, options, onConfirm, onCancel) {
        this.renderBatchPreviewForm(fileTree, options);
        this.renderHeading(buffer, true);
        this.afterShow = _.bind(function () {
            this.messageInput.focus().select();
        }, this);
        this.show(buffer, options, onConfirm, onCancel);
    },
    showSingle: function (fileView, buffer, options, onConfirm, onCancel) {
        this.renderSinglePreviewForm(fileView, options);
        this.renderHeading(buffer);
        this.afterShow = _.bind(function () {
            this.nameInput.focus().select();
        }, this);
        this.show(buffer, options, onConfirm, onCancel);
    },
    show: function (buffer, options, onConfirm, onCancel) {
        this.buffer = buffer;
        this.options = options;
        this.onConfirm = onConfirm;
        this.onCancel = onCancel;

        if (this.options.message) {
            this.messageInput.val(this.options.message);
        }
        this.sendAsText.toggle(!!this.options.dataURI);
        this.dropped.toggle(!this.options.dropped);

        DialogView.prototype.show.call(this);
    },
    renderBatchPreviewForm: function (fileTree, options) {
        this.$el.addClass('batch');

        this.tree.append(fileTree);

        if (options.truncated) {
            this.maxUploadBatch.text(FileWrapper.MAX_UPLOAD_BATCH);
            this.maxUploadBatchInfo.show();
        }

        this.batch.show();
    },
    renderSinglePreviewForm: function (fileView, options) {
        fileView.renderLocalPreview().done(_.bind(function (preview) {
            this.previewWrapper.append(preview);
        }, this));
        
        this.nameInput.val(fileView.model.getName());

        this.info.text(fileView.model.getSize() + ' • ' + fileView.model.getType());

        this.single.show();
    }
});


module.exports = FileUploadDialogView;



//////////////////
// WEBPACK FOOTER
// ./app/src/view/fileuploaddialogview.js
// module id = ET1g
// module chunks = 1